import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getUserRole } from "../services/authService";

// Simple component to test role-based redirects
function RoleBasedRedirect() {
  console.log("=== RoleBasedRedirect Component ===");

  if (!isAuthenticated()) {
    console.log("Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  const userRole = getUserRole();
  console.log("User role detected:", userRole);

  switch (userRole) {
    case "admin":
      console.log("Redirecting admin to dashboard");
      return <Navigate to="/dashboard" replace />;
    case "investor":
      console.log("Redirecting investor to investor dashboard");
      return <Navigate to="/investor-dashboard" replace />;
    default:
      console.log("Unknown role, redirecting to login");
      localStorage.removeItem("token");
      return <Navigate to="/login" replace />;
  }
}

export default RoleBasedRedirect;
